import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

export const stays = () => {
  const sliders = document.querySelectorAll('.future-stays .swiper') as NodeListOf<HTMLDivElement>;

  sliders.forEach(slider => {
    const wrapper = slider.querySelector('.swiper-wrapper') as HTMLDivElement;
    const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

    // 🔁 Duplique jusqu’à atteindre au moins 5 slides
    const minSlides = 5;
    let currentSlides = [...originalSlides];
    while (currentSlides.length < minSlides) {
      originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        wrapper.appendChild(clone);
        currentSlides.push(clone as HTMLElement);
      });
    }

    // 🚀 Initialise le Swiper
    const swiper = new Swiper(slider, {
      modules: [Autoplay],
      loop: true,
      speed: 5000,
      slidesPerView: "auto",
      freeMode: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });

    // 🛑 Stop autoplay au hover
    slider.addEventListener('mouseenter', () => {
      swiper.autoplay.stop();
    });

    // ▶️ Relance autoplay au leave
    slider.addEventListener('mouseleave', () => {
      swiper.autoplay.start();
    });
  });
};
